import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';

import { Button, ButtonType, Link } from '../../components';
import { useDependencies } from '../../dependencies';

export const VerificationProcessing = observer((): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useTranslation();
  const refresh = (): void => {
    stores.verification.getStripeVerification();
  }

  return (
    <div>
      <div className='font-bold text-xl mb-5'><FontAwesomeIcon icon={faIdCard} /> {t('identityCheck.processing.header')}</div>
      <div className='mb-4'>{t('identityCheck.processing.description')}</div>
      <div className='text-center'>
        <Button
          buttonType={ButtonType.primary}
          disabled={stores.verification.loadingStripe}
          onClick={refresh}>
          {t('identityCheck.processing.refresh')}
        </Button>
        <p className='text-xs mt-4'>
          {t('identityCheck.processing.contact')} &nbsp;
          <Link
            className='hover:text-sapphire-300'
            to={`mailto:${t('common.supportEmail')}`}
            title='Contact Support'
            newTab
            external
          >
            {t('common.supportEmail')}
          </Link>
        </p>
      </div>
    </div>
  );
});
